import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import MapViewer from '@/modules/company/components/OfficeMap/components/MapViewer';


const MapViewerViewWidget = ({ coordinates, label, zoom, ...rest }) => {
  const { t } = useTranslation('structure');
  return (
    <div>
      {label && <div className="ant-col ant-form-item-label mb-1">{t(label) + ':'}</div>}
      <MapViewer isOnClickActive={false} coordinates={coordinates} zoom={zoom} {...rest}/>
    </div>
  );
};

MapViewerViewWidget.propTypes = {
  value: PropTypes.any,
  zoom: PropTypes.any,
  label: PropTypes.string,
  coordinates: PropTypes.any
};

MapViewerViewWidget.defaultProps = {
  zoom: 15,
};

export default memo(MapViewerViewWidget);
